import React, { FC } from "react";
import { Box, Grid, InputLabel, Tooltip } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../model/styles";

const FormViewTextField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const inputRender = (isInGrid: boolean) => {
    return (
      <Box
        component="section"
        sx={{
          p: 1,
          border: "1px solid #DBDBDB",
          // borderRadius: "5px",
          borderTopRightRadius: "5px",
          borderBottomRightRadius: "5px",
          height: props?.value?.length > 26 ? "36px" : "19px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // marginTop: props?.marginTopVal || ''
        }}
      >
        {props?.value}
      </Box>
    );
  };
  return (
    <>
      {props?.label ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{
              marginTop: props?.isNonMarginTop ? "0px !important" : "",
              marginBottom: "6px",
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormViewTextField;
